<ul>
  <li *ngFor="let link of navLinks">
    <a [routerLink]="[]" [fragment]="link.fragment">
      {{ link.label }}
    </a>
  </li>
</ul>
